import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["name", "id", "disabled", "aria-invalid", "aria-describedby"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "form__indicator"
}
const _hoisted_4 = ["id"]

import { Status, validateBoolean } from '@/validation'
import { requiredBoolean } from '@/validation/rules';
import {ref, watch} from "vue";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormCheckbox',
  props: {
    name: {},
    modelValue: { type: Boolean },
    label: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "validated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line
__expose({
  //to call validation in parent.
  validateInput: validateCheckbox
})

// eslint-disable-next-line
const emit = __emit;

const status = ref<Status>( { valid: true });
const checked = ref<boolean>(props.modelValue);

watch(() => props.modelValue, (value) => checked.value = value);

function handleChange(e: Event) {
  const checked = (e.target as HTMLInputElement).checked;

  validateCheckbox(checked);

  emit("update:modelValue", checked);
}

function handleBlur(e: Event) {
  const checked = (e.target as HTMLInputElement).checked;
  validateCheckbox(checked)
}

function validateCheckbox(checked:boolean) {
  status.value = validateBoolean(checked, props.required ? [requiredBoolean] : []);
  emit("validated", props.name, status.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form__field", {'error':!status.value.valid}])
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      name: _ctx.name,
      id: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
      disabled: _ctx.disabled,
      onChange: handleChange,
      onBlur: handleBlur,
      "aria-invalid": !status.value.valid,
      "aria-describedby": 'error__' + _ctx.name
    }, null, 40, _hoisted_1), [
      [_vModelCheckbox, checked.value]
    ]),
    _createElementVNode("label", { for: _ctx.name }, [
      _createTextVNode(_toDisplayString(_ctx.label ? _ctx.label : _ctx.name) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    (!status.value.valid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "form__error-message",
          id: 'error' + _ctx.name
        }, _toDisplayString(status.value.message), 9, _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}
}

})